export const NAME = "feed"
export const FIREBASE_PATH = "feed"
